import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelInventoryImport_ShellService } from './ExcelInventoryImport.shell.service';
import { ExcelInventoryImport_OperationService } from './ExcelInventoryImport.operation.service';
import { ExcelInventoryImport_DatasourceService } from './ExcelInventoryImport.datasource.index';
import { ExcelInventoryImport_FlowService } from './ExcelInventoryImport.flow.index';
import { ExcelInventoryImport_ReportService } from './ExcelInventoryImport.report.index';
import { ExcelInventoryImport_LocalizationService } from './ExcelInventoryImport.localization.service';
import { ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService } from './ExcelInventoryImport.excel_inventory_import_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelInventoryImport.frontend.types'
import { $frontendTypes as $types} from './ExcelInventoryImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IExcelInventoryImport_excel_inventory_import_gridComponentEntity {
  LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, ReceiveDate?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } } }, Status?: { Id?: number, Name?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string } }, LicensePlate?: { LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } } }, Packaged?: { Id?: number, ShortName?: string, WeightUom?: { Id?: number, Short_name?: string } }}



class ExcelInventoryImport_excel_inventory_import_gridComponentRowModel extends GridRowModel {
  grid: ExcelInventoryImport_excel_inventory_import_gridComponent;
  entity: IExcelInventoryImport_excel_inventory_import_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    owner_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    project_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    warehouse_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    location_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    licenseplate_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    material_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    lot_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    vendorlot_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    packaging_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    packaged_amount_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    serial_number_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    net_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    gross_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    reasoncode_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    vendorlot_manufacture_date_on_creation_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    vendorlot_expiration_date_on_creation_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    lot_receive_date_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    content_id: null,
    row_number: null,
    errors: null,
    owner: null,
    project: null,
    warehouse: null,
    location: null,
    licenseplate: null,
    material: null,
    lot: null,
    vendorlot: null,
    packaging: null,
    packaged_amount: null,
    serial_number: null,
    net_weight: null,
    gross_weight: null,
    weight_uom: null,
    reasoncode: null,
    vendorlot_manufacture_date_on_creation: null,
    vendorlot_expiration_date_on_creation: null,
    lot_receive_date: null,
  }



  constructor(
    grid: ExcelInventoryImport_excel_inventory_import_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelInventoryImport_ShellService,
private $datasources: ExcelInventoryImport_DatasourceService,
private $flows: ExcelInventoryImport_FlowService,
private $reports: ExcelInventoryImport_ReportService,
private $localization: ExcelInventoryImport_LocalizationService,
private $operations: ExcelInventoryImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.content_id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.content_id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.row_number = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.row_number,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.errors = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.errors,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.owner,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['owner_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['project_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['warehouse_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.location = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.location,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['location_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.licenseplate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.licenseplate,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['licenseplate_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['material_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['lot_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.vendorlot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendorlot,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['vendorlot_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['packaging_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaged_amount,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['packaged_amount_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.serial_number = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.serial_number,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['serial_number_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.net_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['net_weight_edit'] as DatexFormControl, null, true, false, '', '', null)
      );
    
    this.cells.gross_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['gross_weight_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['weight_uom_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.reasoncode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.reasoncode,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['reasoncode_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.vendorlot_manufacture_date_on_creation = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendorlot_manufacture_date_on_creation,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['vendorlot_manufacture_date_on_creation_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.vendorlot_expiration_date_on_creation = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendorlot_expiration_date_on_creation,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['vendorlot_expiration_date_on_creation_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.lot_receive_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot_receive_date,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['lot_receive_date_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    
  }

  async $initializeExisting(entity: IExcelInventoryImport_excel_inventory_import_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelInventoryImport_excel_inventory_import_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'LicensePlateId',this.entity.LicensePlateId);
    set($resultKey, 'LotId',this.entity.LotId);
    set($resultKey, 'PackagedId',this.entity.PackagedId);
    const inParams = {
      $keys:[$resultKey],
      warehouseId:  0 ,
    };
    const data = await this.$datasources.ExcelInventoryImport.ds_inventory_import_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelInventoryImport_excel_inventory_import_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.content_id.displayControl as TextModel).text = $utils.isDefined($row.entity) ? `${$row.entity?.LicensePlateId}:${$row.entity?.LotId}:${$row.entity?.PackagedId}` : '';
    (this.cells.owner.displayControl as TextModel).text = $row.entity.Lot?.Material?.Project?.Owner?.LookupCode;
    
    (this.cells.project.displayControl as TextModel).text = $row.entity.Lot?.Material?.Project?.LookupCode;
    
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Warehouse?.Name;
    
    (this.cells.location.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Name;
    
    (this.cells.licenseplate.displayControl as TextModel).text = $row.entity.LicensePlate?.LookupCode;
    (this.cells.licenseplate.editControl as TextBoxModel).reset($row.entity.LicensePlate?.LookupCode);
    (this.cells.material.displayControl as TextModel).text = $row.entity.Lot?.Material?.LookupCode;
    
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.lot.editControl as TextBoxModel).reset($row.entity.Lot?.LookupCode);
    (this.cells.vendorlot.displayControl as TextModel).text = $row.entity.Lot?.VendorLot?.LookupCode;
    (this.cells.vendorlot.editControl as TextBoxModel).reset($row.entity.Lot?.VendorLot?.LookupCode);
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.Packaged?.ShortName?.toString();
    
    (this.cells.packaged_amount.displayControl as TextModel).text = $row.entity.PackagedAmount?.toString();
    (this.cells.packaged_amount.editControl as NumberBoxModel).reset($row.entity.PackagedAmount);
    
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity?.Packaged?.WeightUom.Short_name?.toString();
    
    
    (this.cells.vendorlot_manufacture_date_on_creation.displayControl as TextModel).text = $row.entity?.Lot?.VendorLot?.ManufactureDate?.toString();
    
    (this.cells.vendorlot_expiration_date_on_creation.displayControl as TextModel).text = $row.entity?.Lot?.VendorLot?.ExpirationDate?.toString();
    
    (this.cells.lot_receive_date.displayControl as TextModel).text = $row.entity.Lot?.ReceiveDate?.toString();
    

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_confirm_row();
      this.isNew = false;
    } else {
      await this.on_confirm_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_confirm_row(event = null) {
    return this.on_confirm_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_rowInternal(
    $row: ExcelInventoryImport_excel_inventory_import_gridComponentRowModel,
  $grid: ExcelInventoryImport_excel_inventory_import_gridComponent, 
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  $grid.vars.rowsToImport = [$row];
  
  await $grid.common_import_rows();
  
  if ($utils.isDefined($row.cells.errors.displayControl.text)) {
      throw new Error($row.cells.errors.displayControl.text);
  }
  }
  on_row_init(event = null) {
    return this.on_row_initInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_initInternal(
    $row: ExcelInventoryImport_excel_inventory_import_gridComponentRowModel,
  $grid: ExcelInventoryImport_excel_inventory_import_gridComponent, 
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelInventoryImport', 'excel_inventory_import_grid.on_row_init');
  // Set row_number
  $row.cells.row_number.displayControl.text = 
      (Math.max(...$grid.rows
          .filter(r => $utils.isDefined(r.cells.row_number.displayControl.text))
          .map(r => Number(r.cells.row_number.displayControl.text))) + 1
      ).toString();
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'ExcelInventoryImport-excel_inventory_import_grid',
  templateUrl: './ExcelInventoryImport.excel_inventory_import_grid.component.html'
})
export class ExcelInventoryImport_excel_inventory_import_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelInventoryImport_excel_inventory_import_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);




  //#region Variables
  vars: { rowsToImport?: any } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     content_id: new GridHeaderModel(new HeaderStyles(null, null), 'content_id', 'Content ID', false, false, null, false),       row_number: new GridHeaderModel(new HeaderStyles(null, null), 'row_number', 'Row', false, false, null, false),       errors: new GridHeaderModel(new HeaderStyles(null, null), 'errors', 'Error(s)', false, false, null, false),       owner: new GridHeaderModel(new HeaderStyles(null, null), 'owner', 'Owner', true, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', true, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', true, false, null, false),       location: new GridHeaderModel(new HeaderStyles(null, null), 'location', 'Location', true, false, null, false),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate', 'License plate', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', true, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       vendorlot: new GridHeaderModel(new HeaderStyles(null, null), 'vendorlot', 'Vendor lot', false, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', true, false, null, false),       packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'packaged_amount', 'Packaged amount', false, false, null, false),       serial_number: new GridHeaderModel(new HeaderStyles(null, null), 'serial_number', 'Serial number', false, false, null, false),       net_weight: new GridHeaderModel(new HeaderStyles(null, null), 'net_weight', 'Net weight', false, false, null, false),       gross_weight: new GridHeaderModel(new HeaderStyles(null, null), 'gross_weight', 'Gross weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight UOM', false, false, null, false),       reasoncode: new GridHeaderModel(new HeaderStyles(null, null), 'reasoncode', 'Reason code', true, false, null, false),       vendorlot_manufacture_date_on_creation: new GridHeaderModel(new HeaderStyles(null, null), 'vendorlot_manufacture_date_on_creation', 'Manufacture date', false, false, null, false),       vendorlot_expiration_date_on_creation: new GridHeaderModel(new HeaderStyles(null, null), 'vendorlot_expiration_date_on_creation', 'Expiration date', false, false, null, false),       lot_receive_date: new GridHeaderModel(new HeaderStyles(null, null), 'lot_receive_date', 'Receive date', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelInventoryImport_excel_inventory_import_gridComponentRowModel[] = [];


  topToolbar = {
      lineCount: new ToolModel(new ButtonModel('lineCount', new ButtonStyles(null, null), false, false, false, 'LineCount', '', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelInventoryImport_ShellService,
    private $datasources: ExcelInventoryImport_DatasourceService,
    private $flows: ExcelInventoryImport_FlowService,
    private $reports: ExcelInventoryImport_ReportService,
    private $localization: ExcelInventoryImport_LocalizationService,
    private $operations: ExcelInventoryImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Inventory Import';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseId:  0 ,
    };
    try {
      const data = await this.$datasources.ExcelInventoryImport.ds_inventory_import_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelInventoryImport_excel_inventory_import_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelInventoryImport_excel_inventory_import_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IExcelInventoryImport_excel_inventory_import_gridComponentEntity) {
    const row = new ExcelInventoryImport_excel_inventory_import_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.lineCount.hidden = true;
  $grid.vars.rowsToImport = [];
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  /************ Initialize ************/
  // Interface
  $grid.topToolbar.lineCount.hidden = false;
  $grid.topToolbar.lineCount.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.lineCount.control.label = "Extracting data...";
  
  /******* Extract data from Excel *******/
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  var inventoryData = $utils.excel.sheet_to_json<{
      "Owner": string,
      "Project": string,
      "Warehouse": string,
      "Location": string,
      "LicensePlate": string,
      "Material": string,
      "VendorLot": string,
      "Lot": string,
      //"Vat": string,
      "Packaging": string,
      "PackagedAmount": string,
      "SerialNumber": string,
      "NetWeight": string,
      "GrossWeight": string,
      "WeightUOM": string,
      "ReasonCode": string,
      "ManufactureDate": string,
      "ExpirationDate": string,
      "ReceiveDate": string
  }>(ws, { raw: false, dateNF: $settings.ExcelInventoryImport.DateFormat });
  
  var totalLineCount = inventoryData.length;
  
  $grid.topToolbar.lineCount.control.label = "Preparing data...";
  
  /************ Import into grid ************/
  // Variables
  var lineCount = 0;
  
  for (let inventory of inventoryData) {
      // Initialize new row
      lineCount++;
      $grid.topToolbar.lineCount.control.label = `Creating Line ${lineCount} of ${totalLineCount}`;
      var row = await $grid.addRow();
  
      let originFormat: string;
  
      let manufacture_date: string;
      let expiration_date: string;
      let receive_date: string;
  
      if ($utils.isDefined(inventory.ManufactureDate)) {
          manufacture_date = (await $flows.ExcelInventoryImport.parse_date_string({ date: inventory.ManufactureDate })).date;
      }
  
      if ($utils.isDefined(inventory.ExpirationDate)) {
          expiration_date = (await $flows.ExcelInventoryImport.parse_date_string({ date: inventory.ExpirationDate })).date;
      }
  
      if ($utils.isDefined(inventory.ReceiveDate)) {
          receive_date = (await $flows.ExcelInventoryImport.parse_date_string({ date: inventory.ReceiveDate })).date;
      }
  
      // Set values
      row.cells.row_number.displayControl.text = lineCount.toString();
      row.cells.owner.editControl.value = inventory.Owner;
      row.cells.project.editControl.value = inventory.Project;
      row.cells.warehouse.editControl.value = inventory.Warehouse;
      row.cells.location.editControl.value = inventory.Location;
      row.cells.licenseplate.editControl.value = inventory.LicensePlate;
      row.cells.material.editControl.value = inventory.Material;
      row.cells.vendorlot.editControl.value = inventory.VendorLot;
      //row.cells.vat.editControl.value = inventory.Vat ?? null;
      row.cells.lot.editControl.value = inventory.Lot;
      row.cells.packaging.editControl.value = inventory.Packaging;
      row.cells.packaged_amount.editControl.value = inventory.PackagedAmount ?? null;
      row.cells.serial_number.editControl.value = inventory.SerialNumber;
      row.cells.net_weight.editControl.value = inventory.NetWeight ?? null;
      row.cells.gross_weight.editControl.value = inventory.GrossWeight ?? null;
      row.cells.weight_uom.editControl.value = inventory.WeightUOM;
      row.cells.reasoncode.editControl.value = inventory.ReasonCode;
      row.cells.vendorlot_manufacture_date_on_creation.editControl.value = manufacture_date;
      row.cells.vendorlot_expiration_date_on_creation.editControl.value = expiration_date;
      row.cells.lot_receive_date.editControl.value = receive_date;
  
      // Add to collection to import
      $grid.vars.rowsToImport.push(row);
  }
  
  await $grid.common_import_rows();
  
  $grid.topToolbar.lineCount.hidden = true;
  }
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  var wb = $event;
  
  var inventory = [];
  
  if ($grid.rows.length > 0) {
      for (let row of $grid.rows) {
          inventory.push({
              "Owner": row.cells.owner.displayControl.text,
              "Project": row.cells.project.displayControl.text,
              "Warehouse": row.cells.warehouse.displayControl.text,
              "Location": row.cells.location.displayControl.text,
              "LicensePlate": row.cells.licenseplate.displayControl.text,
              "Material": row.cells.material.displayControl.text,
              "Lot": row.cells.lot.displayControl.text,
              "VendorLot": row.cells.vendorlot.displayControl.text,
              //"Vat": row.cells.vat.displayControl.text,
              "Packaging": row.cells.packaging.displayControl.text,
              "PackagedAmount": row.cells.packaged_amount.displayControl.text,
              "SerialNumber": row.cells.serial_number.displayControl.text,
              "NetWeight": row.cells.net_weight.displayControl.text,
              "GrossWeight": row.cells.gross_weight.displayControl.text,
              "WeightUOM": row.cells.weight_uom.displayControl.text,
              "ReasonCode": row.cells.reasoncode.displayControl.text,
              "ManufactureDate": row.cells.vendorlot_manufacture_date_on_creation.displayControl.text,
              "ExpirationDate": row.cells.vendorlot_expiration_date_on_creation.displayControl.text,
              "ReceiveDate": row.cells.lot_receive_date.displayControl.text
          });
      }
  }
  else {
      inventory.push({
              "Owner": "String",
              "Project": "String",
              "Warehouse": "String",
              "Location": "String",
              "LicensePlate": "String",
              "Material": "String",
              "Lot": "String",
              "VendorLot": "String",
              //"Vat": "String",
              "Packaging": "EA, CA, PK, etc.",
              "PackagedAmount": "Integer",
              "SerialNumber": "String",
              "NetWeight": "Decimal",
              "GrossWeight": "Decimal",
              "WeightUOM": "lb, kg",
              "LotStatus": "Active, Inactive, Damaged, etc.",
              "ReasonCode": "String",
              "ManufactureDate": "dd/MM/yyyy",
              "ExpirationDate": "dd/MM/yyyy",
              "ReceiveDate": "dd/MM/yyyy"
          });
  }
  
  const ws = $utils.excel.json_to_sheet(inventory);
  
  $utils.excel.book_append_sheet(wb, ws, "InventoryImportTemplate");
  
  
  }
  common_import_rows(event = null) {
    return this.common_import_rowsInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async common_import_rowsInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  class Content {
      material: any;
      materialPackaging: any;
      vendorlot: any;
      lot: any;
      licensePlate: any;
      contentExists: boolean;
      packagedAmount: number;
      reasoncodeId: number;
      weightUomId: number;
      rows: any[];
  
      constructor(
          material: any,
          packaging: any,
          vendorLot: any,
          lot: any,
          licensePlate: any,
          contentExists: boolean,
          packagedAmount: number,
          reasoncodeId: number,
          weightUomId: number,
          rows: any
      ) {
          this.material = material;
          this.materialPackaging = packaging;
          this.vendorlot = vendorLot;
          this.lot = lot;
          this.licensePlate = licensePlate;
          this.contentExists = contentExists;
          this.packagedAmount = packagedAmount;
          this.reasoncodeId = reasoncodeId;
          this.weightUomId = weightUomId;
          this.rows = rows;
      }
  }
  
  $grid.topToolbar.lineCount.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.lineCount.control.label = "Processing data...";
  
  var rowsToImport: any[] = $grid.vars.rowsToImport;
  
  var totalLineCount = rowsToImport?.length;
  
  /************ Compile Distinct values ************/
  const batchSize = 100;
  
  var ownersPool = (await getOwnersPool());
  var projectsPool = (await getProjectsPool());
  var materialsPool = (await getMaterialsPool());
  var locationsPool = (await getLocationsPool());
  var licensePlatesPool = (await getLicensePlatesPool());
  
  const weightUnitsPool = (await $datasources.ExcelInventoryImport.ds_measurement_units_dd.get({ typeId: 3 })).result;
  const materialStatusesPool = (await $datasources.ExcelInventoryImport.ds_material_statuses_dd.get({})).result;
  const reasoncodesPool = (await $datasources.ExcelInventoryImport.ds_reasoncodes_dd.get({ parentEntity: 'OperationType', parentId: 1 })).result;
  
  
  
  /************ Import into grid ************/
  // Variables
  var candidateContents: Content[] = new Array();
  let errors: string;
  let serialNumbers: string[] = new Array();
  
  for (let row of rowsToImport) {
      $grid.topToolbar.lineCount.control.label = `Validating Row ${row.cells.row_number.displayControl.text} of ${Math.max(...$grid.rows.map(r => Number(r.cells.row_number.displayControl.text)))}`;
      row.cells.errors.displayControl.text = '';
      errors = '';
  
      let owner = validateOwner(row, row.cells.owner.editControl.value);
      let project = validateProject(row, owner, row.cells.project.editControl.value);
      let material = validateMaterial(row, project, row.cells.material.editControl.value);
      let materialPackaging = validatePackaging(row, material, row.cells.packaging.editControl.value);
      let vendorLot = validateLot(row, material, row.cells.vendorlot.editControl.value, row.cells.lot.editControl.value);
      let lot = $utils.isDefined(vendorLot?.Lots) ? vendorLot.Lots[0] : undefined;
      let locationContainer = validateLocation(row, row.cells.warehouse.editControl.value, row.cells.location.editControl.value);
      let licensePlate = validateLicensePlate(row, locationContainer, row.cells.licenseplate.editControl.value);
      let reasoncode = validateReasonCode(row, row.cells.reasoncode.editControl.value);
      let weightUom = validateWeightUom(row, material, row.cells.weight_uom.editControl.value);
      //let status = validateMaterialStatus(row, lot, row.cells.lot_status_on_creation.editControl.value);
  
      validateSerialNumberPackagedAmount(row, material, row.cells.serial_number.editControl.value, row.cells.packaged_amount.editControl.value, materialPackaging);
      validateWeights(row, material, row.cells.net_weight.editControl.value, row.cells.gross_weight.editControl.value);
  
      let receiveDate: string = $utils.date.format((new Date()).toString());
      if ($utils.isDefined(lot?.ReceiveDate)) {
          receiveDate = lot?.ReceiveDate;
      }
      else if ($utils.isDefined(row.cells.lot_receive_date.editControl.value)) {
          receiveDate = (await $flows.ExcelInventoryImport.format_date_string({ dateString: row.cells.lot_receive_date.editControl.value, fromFormat: $settings.ExcelInventoryImport.DateFormat, toFormat: 'YYYY-MM-DD' })).dateString;
      }
  
      let manufactureDate: string = $utils.date.format((new Date()).toString());
      if ($utils.isDefined(vendorLot?.ManufactureDate)) {
          manufactureDate = vendorLot?.ManufactureDate;
      }
      else if ($utils.isDefined(row.cells.vendorlot_manufacture_date_on_creation.editControl.value)) {
          manufactureDate = (await $flows.ExcelInventoryImport.format_date_string({ dateString: row.cells.vendorlot_manufacture_date_on_creation.editControl.value, fromFormat: $settings.ExcelInventoryImport.DateFormat, toFormat: 'YYYY-MM-DD' })).dateString;
      }
  
      let expirationDate: string = $utils.date.format((new Date()).toString());
      if ($utils.isDefined(vendorLot?.ExpirationDate)) {
          expirationDate = vendorLot?.ExpirationDate;
      }
      else if ($utils.isDefined(row.cells.vendorlot_expiration_date_on_creation.editControl.value)) {
          expirationDate = (await $flows.ExcelInventoryImport.format_date_string({ dateString: row.cells.vendorlot_expiration_date_on_creation.editControl.value, fromFormat: $settings.ExcelInventoryImport.DateFormat, toFormat: 'YYYY-MM-DD' })).dateString;
      }
      validateNewLot(row, vendorLot, manufactureDate, expirationDate, receiveDate, lot);
  
      let vat: string = row.cells.vat.editControl.value
  
  
      // Finalize row
      if ($utils.isDefined(errors)) {
          row.cells.errors.displayControl.text = errors;
      }
      else {
          // Calculate fields
          let vendorLotLookupCode = vendorLot?.LookupCode ?? row.cells.vendorlot.editControl.value;
          let lotLookupCode = lot?.LookupCode ?? row.cells.lot.editControl.value;
          if ($utils.isDefined(vendorLotLookupCode) && !$utils.isDefined(lotLookupCode)) {
              lotLookupCode = vendorLotLookupCode;
          }
          if (!$utils.isDefined(vendorLotLookupCode) && $utils.isDefined(lotLookupCode)) {
              vendorLotLookupCode = lotLookupCode;
          }
  
          let licensePlateLookupCode = licensePlate?.LookupCode ?? row.cells.licenseplate.editControl.value;
  
          // Find if content already exists
          var matchingCandidate = candidateContents.find(c => c.material.Id === material.Id &&
              c.materialPackaging.PackagingId === materialPackaging.PackagingId &&
              c.licensePlate.LocationId === locationContainer.Id &&
              equalsIgnoreCase(c.vendorlot.LookupCode, vendorLotLookupCode) &&
              equalsIgnoreCase(c.lot.LookupCode, lotLookupCode) &&
              equalsIgnoreCase(c.licensePlate.LookupCode, licensePlateLookupCode)
          );
  
          if ($utils.isDefined(matchingCandidate)) {
              matchingCandidate.packagedAmount += Number(row.cells.packaged_amount.editControl.value) ?? 1;
              matchingCandidate.rows.push(row);
          }
          else {
              candidateContents.push(
                  new Content(
                      material,
                      materialPackaging,
                      { // VendorLot
                          Id: vendorLot?.Id,
                          LookupCode: vendorLotLookupCode,
                          ManufactureDate: manufactureDate,
                          ExpirationDate: expirationDate,
                          Vat: vat ?? null
                      },
                      { // Lot
                          Id: lot?.Id,
                          LookupCode: lotLookupCode,
                          StatusId: lot?.StatusId ?? 1,
                          ReceiveDate: receiveDate
                      },
                      { // LicensePlate
                          Id: licensePlate?.Id,
                          LookupCode: licensePlateLookupCode,
                          LocationId: locationContainer.Id
                      },
                      $utils.isDefined(licensePlate?.LicensePlateContents?.filter(lpc => lpc.LotId === lot?.Id && lpc.PackagedId === materialPackaging.PackagingId)),
                      Number(row.cells.packaged_amount.editControl.value) ?? 1,
                      reasoncode.Id,
                      weightUom?.Id ?? materialPackaging.WeightUOM,
                      [row]
                  )
              );
          }
      }
  }
  
  // TODO: License Plate validation: license plate not already created in another location within same excel
  // TODO: Check for existing serials / remove from candidates
  for (let content of candidateContents) {
      $grid.topToolbar.lineCount.control.label = `Importing Grouped Content ${candidateContents.indexOf(content)} of ${candidateContents.length}`;
      try {
          let start = new Date();
  
          content.vendorlot.Id = await getVendorLot(content.material.Id, content.vendorlot);
          content.lot.Id = await getLot(content.vendorlot.Id, content.lot);
          await createLicensePlateContents(content);
  
          content.rows.sort((a, b) => Number(a.cells.row_number.displayControl.text) - Number(b.cells.row_number.displayControl.text));
  
          for (let row of content.rows) {
  
              row.cells.content_id.displayControl.text = `${content.licensePlate.Id}:${content.lot.Id}:${content.materialPackaging.PackagingId}`;
  
              lockCell(row.cells.owner);
              lockCell(row.cells.project);
              lockCell(row.cells.warehouse);
              lockCell(row.cells.location);
              lockCell(row.cells.licenseplate);
              lockCell(row.cells.material);
              lockCell(row.cells.vendorlot);
              lockCell(row.cells.lot);
              lockCell(row.cells.packaging);
              lockCell(row.cells.serial_number);
              lockCell(row.cells.packaged_amount);
              lockCell(row.cells.net_weight);
              lockCell(row.cells.gross_weight);
              lockCell(row.cells.weight_uom);
              lockCell(row.cells.reasoncode);
              lockCell(row.cells.vendorlot_expiration_date_on_creation);
              lockCell(row.cells.vendorlot_manufacture_date_on_creation);
              lockCell(row.cells.lot_receive_date);
              lockCell(row.cells.vat);
  
              row.setDisplayMode();
              row.isNew = false;
          }
      }
      catch (error) {
          for (let row of content.rows) {
              row.cells.errors.displayControl.text = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error.message;
  
              unlockCell(row.cells.owner);
              unlockCell(row.cells.project);
              unlockCell(row.cells.warehouse);
              unlockCell(row.cells.location);
              unlockCell(row.cells.licenseplate);
              unlockCell(row.cells.material);
              unlockCell(row.cells.vendorlot);
              unlockCell(row.cells.lot);
              unlockCell(row.cells.packaging);
              unlockCell(row.cells.serial_number);
              unlockCell(row.cells.packaged_amount);
              unlockCell(row.cells.net_weight);
              unlockCell(row.cells.gross_weight);
              unlockCell(row.cells.weight_uom);
              unlockCell(row.cells.reasoncode);
              unlockCell(row.cells.vendorlot_expiration_date_on_creation);
              unlockCell(row.cells.vendorlot_manufacture_date_on_creation);
              unlockCell(row.cells.lot_receive_date);
              unlockCell(row.cells.vat);
          }
      }
  }
  
  $grid.rows.sort((a, b) =>
      $utils.isDefined(a.cells.errors.displayControl.text) && !$utils.isDefined(b.cells.errors.displayControl.text) ?
          -1 :
          $utils.isDefined(b.cells.errors.displayControl.text) && !$utils.isDefined(a.cells.errors.displayControl.text) ?
              1 :
              Number(a.cells.row_number.displayControl.text) < Number(b.cells.row_number.displayControl.text) ?
                  -1 :
                  Number(b.cells.row_number.displayControl.text) < Number(a.cells.row_number.displayControl.text) ?
                      1 :
                      0
  );
  
  
  $grid.topToolbar.lineCount.control.label = `Import completed`;
  $grid.topToolbar.lineCount.control.icon = "icon ms-Icon ms-Icon--Accept";
  
  $grid.vars.rowsToImport = [];
  
  /*********************************************************************/
  /********************** FUNCTIONS ************************************/
  /*********************************************************************/
  /****** TOOLS ******/
  function unlockCell(cell: any) {
      cell.editControl.readOnly = false;
      cell.editControl.styles.resetStyle();
  }
  
  function lockCell(cell: any) {
      if (!$utils.isDefined(cell.displayControl.text)) {
          cell.displayControl.text = cell.editControl?.value
      }
  
      cell.editControl.readOnly = true;
      cell.editControl.styles.setStyle('background', 'transparent');
  }
  
  function addError(error: string) {
      if (!$utils.isDefined(errors)) { errors = ''; }
      errors += error + ' : ';
  
      return true;
  }
  
  function equalsIgnoreCase(text, other) {
      text = text?.toString().trim().toUpperCase();
      other = other?.toString().trim().toUpperCase();
      return text == other;
  }
  
  /****** IMPORT ******/
  async function getVendorLot(materialId: number, vendorlot: any) {
      let vendorlotId: number;
  
      if ($utils.isDefined(vendorlot.Id)) {
          vendorlotId = vendorlot.Id;
      }
      else {
          vendorlotId = candidateContents.find(cc =>
              cc.material.Id === materialId &&
              equalsIgnoreCase(cc.vendorlot.LookupCode, vendorlot.LookupCode)
          )?.vendorlot.Id;
  
          if (!$utils.isDefined(vendorlotId)) {
              vendorlotId = (await $flows.ExcelInventoryImport.create_vendor_lot({
                  materialId: materialId,
                  lookupCode: vendorlot.LookupCode,
                  manufactureDate: vendorlot.ManufactureDate,
                  expirationDate: vendorlot.ExpirationDate
              })).vendorLotId;
  
              if ($utils.isDefined(vendorlot.Vat)) {
                  let vendorlotPayload: any = {};
                  vendorlotPayload.Vat = vendorlot.Vat;
                  await $flows.Utilities.crud_update_flow({ entitySet: 'VendorLots', id: vendorlotId, entity: vendorlotPayload });
              }
  
          }
      }
  
      // Update candidateContents
      for (let matchingContent of candidateContents.filter(c => c.material.Id === materialId && !$utils.isDefined(c.vendorlot.Id) && equalsIgnoreCase(c.vendorlot.LookupCode, vendorlot.LookupCode))) {
          matchingContent.vendorlot.Id = vendorlotId;
      }
  
      return vendorlotId;
  }
  async function getLot(vendorLotId: number, lot: any) {
      let lotId: number;
  
      if ($utils.isDefined(lot.Id)) {
          lotId = lot.Id;
      }
      else {
          lotId = candidateContents.find(cc =>
              cc.vendorlot.Id === vendorLotId &&
              equalsIgnoreCase(cc.lot.LookupCode, lot.LookupCode)
          )?.lot.Id;
  
          if (!$utils.isDefined(lotId)) {
              lotId = (await $flows.ExcelInventoryImport.create_lot({
                  vendorLotId: vendorLotId,
                  lookupCode: lot.LookupCode,
                  statusId: lot.StatusId
              })).lotId;
  
              if ($utils.isDefined(lot.ReceiveDate)) {
                  await $flows.Utilities.crud_update_flow({ entitySet: "Lots", id: lotId, entity: { ReceiveDate: lot.ReceiveDate } })
              }
          }
      }
  
      // Update candidateContents
      for (let matchingContent of candidateContents.filter(c => c.vendorlot.Id === vendorLotId && !$utils.isDefined(c.lot.Id) && equalsIgnoreCase(c.lot.LookupCode, lot.LookupCode))) {
          matchingContent.lot.Id = lotId;
      }
  
      return lotId;
  }
  
  async function createLicensePlateContents(content: Content) {
      let isLicensePlateCreated = false;
      let isContentCreated = false;
      let isSerialControlled = content.material.ControllerTypeId === 3 || content.material.ControllerTypeId === 4 || !content.material.IsFixedWeight;
      let isAutogenerateSerialNumbers = content.materialPackaging.AutogenerateSerialNumbers || !content.material.IsFixedWeight;
      let serialNumbers: any[] = [];
  
      // Serial Controlled
      if (isSerialControlled) {
          for (let row of content.rows) {
  
              let packagedAmount = $utils.isDefined(row.cells.packaged_amount.editControl.value) ? row.cells.packaged_amount.editControl.value : 1;
              let nextIdCeiling = (await $flows.Utilities.reserve_batchId_flow({ batchSize: packagedAmount, entity: 'SerialNumber' })).newIdCeiling
              for (let i = 0; i < packagedAmount; i++) {
  
                  serialNumbers.push({
                      LookupCode: row.cells.serial_number.editControl.value ?? 'SI' + (nextIdCeiling - i),
                      NetWeightValue: !content.material.IsFixedWeight && $utils.isDefined(row.cells.net_weight.editControl.value) ? row.cells.net_weight.editControl.value / row.cells.packaged_amount.editControl.value : content.materialPackaging.Weight,
                      GrossWeightValue: !content.material.IsFixedWeight && $utils.isDefined(row.cells.gross_weight.editControl.value) ? row.cells.gross_weight.editControl.value / row.cells.packaged_amount.editControl.value : content.materialPackaging.ShippingWeight,
                      WeightUOM: !content.material.IsFixedWeight ? content.weightUomId : content.materialPackaging.WeightUOM,
                      Width: content.materialPackaging.Width,
                      Height: content.materialPackaging.Height,
                      Length: content.materialPackaging.Length,
                      DimensionUOM: content.materialPackaging.DimensionsUOM,
                      NetVolumeValue: content.materialPackaging.Volume,
                      GrossVolumeValue: content.materialPackaging.ShippingVolume,
                      VolumeUOM: content.materialPackaging.VolumeUOM
                  });
              }
          }
      }
  
      if ($utils.isDefined(content.licensePlate?.Id)) { // LP Exists
          if (content.contentExists) { // LPC Exists
              if (isSerialControlled) {
                  await $flows.ExcelInventoryImport.add_serials_inventory_on_existing_licenseplate_flow({
                      licenseplateId: content.licensePlate.Id,
                      lotId: content.lot.Id,
                      packagingId: content.materialPackaging.PackagingId,
                      serialNumbers: serialNumbers,
                      reasoncodeId: content.reasoncodeId,
                      operationcodeId: 1
                  });
              }
              else {
                  await $flows.ExcelInventoryImport.add_inventory_on_existing_licenseplate_flow({
                      licenseplateId: content.licensePlate.Id,
                      lotId: content.lot.Id,
                      packagingId: content.materialPackaging.PackagingId,
                      packagedAmount: content.packagedAmount,
                      reasoncodeId: content.reasoncodeId,
                      operationcodeId: 1
                  });
              }
          }
          else { // LPC does not exist
              if (isSerialControlled) {
                  await $flows.ExcelInventoryImport.create_serials_inventory_on_existing_licenseplate_flow({
                      licenseplateId: content.licensePlate.Id,
                      lotId: content.lot.Id,
                      packagingId: content.materialPackaging.PackagingId,
                      serialNumbers: serialNumbers,
                      reasoncodeId: content.reasoncodeId,
                      operationcodeId: 7
                  });
              }
              else {
                  await $flows.ExcelInventoryImport.create_inventory_on_existing_licenseplate_flow({
                      licenseplateId: content.licensePlate.Id,
                      lotId: content.lot.Id,
                      packagingId: content.materialPackaging.PackagingId,
                      packagedAmount: content.packagedAmount,
                      reasoncodeId: content.reasoncodeId,
                      operationcodeId: 7
                  });
              }
  
              isContentCreated = true;
          }
      }
      else { // LP does not exist
          if (isSerialControlled) {
              content.licensePlate.Id = (await $flows.ExcelInventoryImport.create_serials_inventory_on_new_licenseplate_flow({
                  licenseplateLookupcode: content.licensePlate.LookupCode,
                  locationId: content.licensePlate.LocationId,
                  lotId: content.lot.Id,
                  packagingId: content.materialPackaging.PackagingId,
                  serialNumbers: serialNumbers,
                  reasoncodeId: content.reasoncodeId,
                  operationcodeId: 7
              })).licenseplateId;
          }
          else {
              content.licensePlate.Id = (await $flows.ExcelInventoryImport.create_inventory_on_new_licenseplate_flow({
                  licenseplateLookupcode: content.licensePlate.LookupCode,
                  locationId: content.licensePlate.LocationId,
                  lotId: content.lot.Id,
                  packagingId: content.materialPackaging.PackagingId,
                  packagedAmount: content.packagedAmount,
                  reasoncodeId: content.reasoncodeId,
                  operationcodeId: 7
              })).licenseplateId;
          }
  
          isLicensePlateCreated = true;
          isContentCreated = true;
      }
  
      // Update Candidate Contents
      if (isLicensePlateCreated) {
          for (let matchingLicensePlate of candidateContents.filter(c => c.licensePlate.LocationId === content.licensePlate.LocationId && !$utils.isDefined(c.licensePlate.Id) && equalsIgnoreCase(c.licensePlate.LookupCode, content.licensePlate.LookupCode))) {
              matchingLicensePlate.licensePlate.Id = content.licensePlate.Id
          }
      }
  
      if (isContentCreated) {
          for (let matchingContent of candidateContents.filter(c => c.licensePlate?.Id === content.licensePlate.Id && c.lot?.Id === content.lot.Id && c.materialPackaging.PackagingId === content.materialPackaging.PackagingId && !content.contentExists)) {
              matchingContent.contentExists = true;
          }
      }
  
  }
  
  /****** VALIDATIONS ******/
  //Owner
  function validateOwner(row: any, ownerLookupCode: string): any {
      var owner: any;
  
      if ($utils.isDefined(ownerLookupCode)) {
          owner = ownersPool.find(o => equalsIgnoreCase(o.LookupCode, ownerLookupCode));
  
          if (!$utils.isDefined(owner)) {
              addError('Owner does not exist');
          }
      }
  
      if ($utils.isDefined(owner)) {
          lockCell(row.cells.owner);
      }
  
      return owner;
  }
  
  // Project
  function validateProject(row: any, owner: any, projectLookupCode: string): any {
      var project: any;
  
      if ($utils.isDefined(projectLookupCode)) {
          let matchingProjects = projectsPool.filter(p =>
              equalsIgnoreCase(p.LookupCode, projectLookupCode) &&
              (!$utils.isDefined(owner) || owner.Id === p.OwnerId)
          );
  
          if ($utils.isDefined(matchingProjects)) {
              if (matchingProjects.length > 1) {
                  addError('Multiple Projects found (specify an Owner)');
              }
              else {
                  project = matchingProjects[0];
              }
          }
          else {
              addError('Project does not exist');
          }
      }
      else {
          if ($utils.isDefined(owner) && owner.Projects.length === 1) {
              project = owner.Projects[0];
          }
          else {
              addError('Project not provided');
          }
      }
  
      if ($utils.isDefined(project)) {
          lockCell(row.cells.project);
          lockCell(row.cells.owner);
      }
  
      return project
  }
  
  // Material
  function validateMaterial(row: any, project: any, materialLookupCode: string) {
      var material
  
      if ($utils.isDefined(project)) {
          if ($utils.isDefined(materialLookupCode)) {
              material = materialsPool.find(m => m.ProjectId == project.Id && equalsIgnoreCase(m.LookupCode, materialLookupCode));
  
              if (!$utils.isDefined(material)) {
                  addError('Material does not exist for Project');
              }
          }
          else {
              addError('Material not provided');
          }
      }
  
      if ($utils.isDefined(material)) {
          lockCell(row.cells.material);
      }
  
      return material;
  }
  
  // Lot
  function validateLot(row: any, material: any, vendorLotLookupCode: string, lotLookupCode: string) {
      var vendorLot: any;
      var matchingVendorLots: any;
      var isErrored = false;
  
      if ($utils.isDefined(material)) {
          if (material.ControllerTypeId === 2 || material.ControllerTypeId === 4) {
              if ($utils.isDefined(vendorLotLookupCode) || $utils.isDefined(lotLookupCode)) {
                  matchingVendorLots = material.VendorLots.filter(vl =>
                      equalsIgnoreCase(vl.LookupCode, vendorLotLookupCode ?? lotLookupCode)
                  );
  
                  if ($utils.isDefined(matchingVendorLots)) {
                      vendorLot = JSON.parse(JSON.stringify(matchingVendorLots[0]));
                      vendorLot.Lots = vendorLot.Lots.filter(l => l.LookupCode === lotLookupCode ?? vendorLotLookupCode);
                  }
              }
              else {
                  isErrored = addError('Lot not provided');
              }
          }
          else {
              matchingVendorLots = material.VendorLots.filter(vl =>
                  vl.Lots.find(l => l.TypeId === 1)
              );
  
              if ($utils.isDefined(matchingVendorLots)) {
                  vendorLot = JSON.parse(JSON.stringify(matchingVendorLots[0]));
  
                  if ($utils.isDefined(vendorLot.Lots)) {
                      if ($utils.isDefined(vendorLotLookupCode) && !equalsIgnoreCase(vendorLotLookupCode, vendorLot.LookupCode)) {
                          isErrored = addError('Invalid VLot provided for GLot material');
                      }
                      else if ($utils.isDefined(lotLookupCode) && !equalsIgnoreCase(lotLookupCode, vendorLot.Lots[0].LookupCode)) {
                          isErrored = addError('Invalid Lot provided for GLot material');
                      }
                  }
                  else {
                      isErrored = addError('Failed to find Lot for GLot material');
                  }
              }
              else {
                  isErrored = addError('Failed to find VendorLot for GLot material');
              }
          }
      }
  
      if (!isErrored) {
          lockCell(row.cells.vendorlot);
          lockCell(row.cells.lot);
      }
  
      return vendorLot;
  }
  
  // Packaging
  function validatePackaging(row: any, material: any, packagingShortName: string) {
      var packaging: any;
  
      if ($utils.isDefined(material)) {
          if ($utils.isDefined(packagingShortName)) {
              packaging = material.PackagingLookups.find(p => equalsIgnoreCase(p.Packaging.ShortName, packagingShortName));
  
              if (!$utils.isDefined(packaging)) {
                  addError('Packaging does not exist for Material');
              }
          }
          else {
              addError('Packaging not provided');
          }
      }
  
      if ($utils.isDefined(packaging)) {
          lockCell(row.cells.packaging);
      }
  
      return packaging;
  }
  
  // Location
  function validateLocation(row: any, warehouseName: string, locationName: string) {
      var location: any;
  
      if ($utils.isDefined(locationName)) {
          var matchingLocations = locationsPool.filter(l =>
              equalsIgnoreCase(l.Name, locationName) &&
              (!$utils.isDefined(warehouseName) || equalsIgnoreCase(l.Warehouse.Name, warehouseName))
          );
  
          if ($utils.isDefined(matchingLocations)) {
              if (matchingLocations.length > 1) {
                  addError('Multiple matching Locations (specify Warehouse)');
              }
              else {
                  location = matchingLocations[0];
              }
          }
          else {
              addError('Location does not exist');
          }
      }
      else {
          addError('Location not provided');
      }
  
      if ($utils.isDefined(location)) {
          lockCell(row.cells.warehouse);
          lockCell(row.cells.location);
      }
  
      return location;
  }
  
  // LicensePlate
  function validateLicensePlate(row: any, locationContainer: any, licensePlateLookupCode: string) {
      var existingLicensePlate: any;
      let isErrored = false;
  
      if (!$utils.isDefined(locationContainer)) { return licensePlateLookupCode; }
  
      if (locationContainer.IsLoose) {
          var matchingLicensePlate = licensePlatesPool.find(lp =>
              lp.LocationId === locationContainer.Id &&
              lp.TypeId === 3 // Loose
          );
  
          if (equalsIgnoreCase(matchingLicensePlate.LookupCode, licensePlateLookupCode) || !$utils.isDefined(licensePlateLookupCode)) {
              existingLicensePlate = matchingLicensePlate;
          }
          else {
              isErrored = addError('Invalid LP for Loose Location');
          }
      }
      else {
          if ($utils.isDefined(licensePlateLookupCode)) {
              var matchingLicensePlates = licensePlatesPool.filter(lp =>
                  !lp.Archived &&
                  equalsIgnoreCase(lp.LookupCode, licensePlateLookupCode) &&
                  lp.WarehouseId === locationContainer.Warehouse.Id
              );
  
              if ($utils.isDefined(matchingLicensePlates)) {
                  if (matchingLicensePlates[0].LocationId === locationContainer.Id) {
                      existingLicensePlate = matchingLicensePlates[0];
                  }
                  else {
                      isErrored = addError('LicensePlate exists in another location');
                  }
              }
          }
          else {
              isErrored = addError('LicensePlate not provided');
          }
      }
  
      if (!isErrored) { lockCell(row.cells.licenseplate); }
  
      return existingLicensePlate;
  }
  
  // WeightUOM
  function validateWeightUom(row: any, material: any, weightUomShortName: string) {
      var weightUom: any;
      let isErrored = false;
  
      weightUom = weightUnitsPool.find(u => equalsIgnoreCase(u.Short_name, weightUomShortName));
  
      if ($utils.isDefined(material) && material.IsFixedWeight) {
          if ($utils.isDefined(weightUomShortName)) {
              isErrored = addError('WeightUOM provided for Fixed-Weight material');
          }
      }
      else {
          if ($utils.isDefined(weightUomShortName)) {
              if (!$utils.isDefined(weightUom)) {
                  isErrored = addError('WeightUOM is not valid');
              }
          }
          else {
              if ($utils.isDefined(material)) {
                  isErrored = addError('WeightUOM not provided');
              }
          }
      }
  
      if (!isErrored) { lockCell(row.cells.weight_uom); }
  
      return weightUom;
  }
  
  // MaterialStatus
  function validateMaterialStatus(row: any, lot: any, statusName: string) {
      var materialStatus;
      var isErrored = false;
  
      if ($utils.isDefined(statusName)) {
          materialStatus = materialStatusesPool.find(s => equalsIgnoreCase(s.Name, statusName?.toString().trim()));
  
          if (!$utils.isDefined(materialStatus)) {
              isErrored = addError('Material Status is not valid');
          }
          else {
              if ($utils.isDefined(lot) && lot.StatusId != materialStatus.Id) {
                  isErrored = addError('LotStatus cannot change for existing lot');
              }
          }
      }
  
      if (!isErrored) { lockCell(row.cells.lot_status_on_creation); }
  
      return materialStatus;
  }
  
  // ReasonCode
  function validateReasonCode(row: any, reasoncodeLookup: string) {
      var reasoncode;
      var isErrored = false;
  
      if ($utils.isDefined(reasoncodeLookup)) {
          reasoncode = reasoncodesPool.find(rc => equalsIgnoreCase(rc.LookupCode, reasoncodeLookup));
  
          if (!$utils.isDefined(reasoncode)) {
              isErrored = addError('ReasonCode is not valid');
          }
      }
      else {
          isErrored = addError('Reason code not provided');
      }
  
      if (!isErrored) { lockCell(row.cells.reasoncode); }
  
      return reasoncode;
  }
  
  // Serial Number
  function validateSerialNumberPackagedAmount(row: any, material: any, serialNumber: string, packagedAmount: string, packaging: any) {
      let isErroredSerialNumber = false;
      let isErroredPackagedAmount = false;
  
      if ($utils.isDefined(material)) {
          if (material.ControllerTypeId === 3 || material.ControllerTypeId === 4) {
              if ($utils.isDefined(packagedAmount) && (isNaN(Number(packagedAmount)) || Number(packagedAmount) === 0)) {
                  isErroredPackagedAmount = addError('Invalid value for PackagedAmount');
              }
              else if (packaging.AutogenerateSerialNumbers) {
                  if ($utils.isDefined(serialNumber)) {
                      isErroredSerialNumber = addError(`SerialNumber provided for packaging that's set to autogenerate`);
                  }
              }
              else {
                  if ($utils.isDefined(packagedAmount) && Number(packagedAmount) > 1) {
                      isErroredPackagedAmount = addError('PackagedAmount cannot exceed 1 for serialized material');
                  }
                  if ($utils.isDefined(serialNumber)) {
                      if (serialNumbers.find(sn => equalsIgnoreCase(sn, serialNumber))) {
                          isErroredSerialNumber = addError('Duplicate SerialNumber');
                      }
                      else {
                          serialNumbers.push(serialNumber);
                      }
                  }
                  else {
                      isErroredSerialNumber = addError('SerialNumber not provided');
                  }
              }
          }
          else {
              if ($utils.isDefined(serialNumber)) {
                  isErroredSerialNumber = addError('SerialNumber provided for non-serialized material');
              }
              if (!$utils.isDefined(packagedAmount)) {
                  isErroredPackagedAmount = addError('PackagedAmount not provided');
              }
              else if (isNaN(Number(packagedAmount))) {
                  isErroredPackagedAmount = addError('Invalid value for PackagedAmount');
              }
              else if (Number(packagedAmount) <= 0) {
                  isErroredPackagedAmount = addError('PackagedAmount must be greater than "0"');
              }
          }
  
          if (!isErroredPackagedAmount) { lockCell(row.cells.packaged_amount); }
          if (!isErroredSerialNumber) { lockCell(row.cells.serial_number); }
      }
  }
  
  // Weights
  function validateWeights(row: any, material: any, netWeight: string, grossWeight: string) {
      let isErroredNetWeight = false;
      let isErroredGrossWeight = false;
  
      if ($utils.isDefined(material)) {
          if (material.IsFixedWeight) {
              if ($utils.isDefined(netWeight)) {
                  isErroredNetWeight = addError('NetWeight invalid for fixed-weight material');
              }
              if ($utils.isDefined(grossWeight)) {
                  isErroredGrossWeight = addError('GrossWeight invalid for fixed-weight material');
              }
          }
          else {
              if ($utils.isDefined(netWeight)) {
                  if (!isNaN(Number(netWeight))) {
                      if (Number(netWeight) <= 0) {
                          isErroredNetWeight = addError('NetWeight must be greater than "0"');
                      }
                  }
                  else {
                      isErroredNetWeight = addError('Invalid NetWeight');
                  }
              }
              else {
                  isErroredNetWeight = addError('NetWeight not provided');
              }
              if ($utils.isDefined(grossWeight)) {
                  if (!isNaN(Number(grossWeight))) {
                      if (Number(grossWeight) <= 0) {
                          isErroredGrossWeight = addError('GrossWeight must be greater than "0"');
                      }
                  }
                  else {
                      isErroredGrossWeight = addError('Invalid GrossWeight');
                  }
              }
              else {
                  isErroredGrossWeight = addError('GrossWeight not provided');
              }
          }
  
          if (!isErroredNetWeight) { lockCell(row.cells.net_weight); }
          if (!isErroredGrossWeight) { lockCell(row.cells.gross_weight); }
      }
  }
  
  // New Lot fields
  function validateNewLot(row: any, vendorLot: any, manufactureDate: string, expirationDate: string, receiveDate: string, lot: any) {
      let isErroredManufactureDate = false;
      let isErroredExpirationDate = false;
      let isErroredReceiveDate = false;
  
      // ManufactureDate
      if ($utils.isDefined(manufactureDate)) {
          let dateValue = new Date($utils.date.format(manufactureDate));
  
          if (isNaN(dateValue.valueOf())) {
              isErroredManufactureDate = addError('ManufactureDate is Invalid');
          }
          else {
              if ($utils.isDefined(vendorLot) && dateValue.getDate() != new Date($utils.date.format(vendorLot?.ManufactureDate)).getDate()) {
                  isErroredManufactureDate = addError('ManufactureDate cannot be set on existing lot');
              }
          }
      }
  
      // ExpirationDate
      if ($utils.isDefined(expirationDate)) {
          let dateValue = new Date($utils.date.format(expirationDate));
  
          if (isNaN(dateValue.valueOf())) {
              isErroredExpirationDate = addError('ExpirationDate is Invalid');
          }
          else {
              if ($utils.isDefined(vendorLot) && dateValue.getDate() != new Date($utils.date.format(vendorLot?.ExpirationDate)).getDate()) {
                  isErroredExpirationDate = addError('ExpirationDate cannot be set on existing lot');
              }
              else {
                  if (dateValue < row.cells.vendorlot_manufacture_date_on_creation.editControl.value) {
                      isErroredExpirationDate = addError('ExpirationDate precedes ManufactureDate')
                  }
              }
          }
      }
  
      // ReceiveDate
      if ($utils.isDefined(receiveDate)) {
          let dateValue = new Date($utils.date.format(receiveDate));
  
          if (isNaN(dateValue.valueOf())) {
              isErroredReceiveDate = addError('ReceiveDate is Invalid');
          }
          else {
              if ($utils.isDefined(lot) && dateValue.getDate() != new Date($utils.date.format(lot?.ReceiveDate)).getDate()) {
                  isErroredReceiveDate = addError('ReceiveDate cannot be set on existing lot');
              }
          }
      }
  
      if (!isErroredManufactureDate && !isErroredExpirationDate && !isErroredReceiveDate) {
          lockCell(row.cells.vendorlot_manufacture_date_on_creation);
          lockCell(row.cells.vendorlot_expiration_date_on_creation);
          lockCell(row.cells.lot_receive_date);
      }
  }
  
  /********** Batch Data ***********/
  async function getOwnersPool() {
      let ownerLookupCodes: string[] = Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.owner.editControl.value)).map(inv => inv.cells.owner.editControl.value.toString())));
      let index = 0;
  
      while (index < ownerLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelInventoryImport.ds_get_owners_by_lookupcodes.get({ lookupCodes: ownerLookupCodes.slice(index, index + batchSize) })).result);
          index += batchSize;
      }
  
      return results
  }
  
  async function getProjectsPool() {
      let projectLookupCodes: string[] = Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.project.editControl.value)).map(inv => inv.cells.project.editControl.value.toString())));
      let index = 0;
  
      while (index < projectLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelInventoryImport.ds_get_projects_by_lookupcodes.get({ lookupcodes: projectLookupCodes.slice(index, index + batchSize) })).result);
          index += batchSize;
      }
  
      return results;
  }
  
  async function getMaterialsPool() {
      let materialLookupCodes: string[] = Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.material.editControl.value)).map(inv => inv.cells.material.editControl.value.toString())));
      let index = 0;
  
      while (index < materialLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelInventoryImport.ds_get_materials_by_lookupcodes.get({ lookupcodes: materialLookupCodes.slice(index, index + batchSize) })).result);
          index += batchSize;
      }
  
      return results;
  }
  
  async function getLocationsPool() {
      let locationNames: string[] = Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.location.editControl.value)).map(inv => inv.cells.location.editControl.value.toString())));
      let index = 0;
  
      while (index < locationNames.length) {
          var results = (results || []).concat((await $datasources.ExcelInventoryImport.ds_get_locations_by_names.get({ names: locationNames.slice(index, index + batchSize) })).result);
          index += batchSize;
      }
  
      return results;
  }
  
  async function getLicensePlatesPool() {
      let licensePlateLookupCodes: string[] = Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.licenseplate.editControl.value)).map(inv => inv.cells.licenseplate.editControl.value.toString())));
      licensePlateLookupCodes = licensePlateLookupCodes.concat(Array.from(new Set($grid.vars.rowsToImport.filter(inv => $utils.isDefinedTrimmed(inv.cells.location.editControl.value)).map(inv => inv.cells.location.editControl.value.toString()))));
      let index = 0;
  
      while (index < licensePlateLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelInventoryImport.ds_get_licenseplates_by_lookupcodes.get({ lookupcodes: licensePlateLookupCodes.slice(index, index + batchSize) })).result);
          index += batchSize;
      }
  
      return results;
  }
  
  
  function padStart(targetString: string, length: number, character: string) {
      while (targetString.length < length) {
          targetString = character + targetString;
      }
  
      return targetString;
  }
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelInventoryImport_excel_inventory_import_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
